import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=2738e7ea&scoped=true"
import script from "./Demand.vue?vue&type=script&lang=js"
export * from "./Demand.vue?vue&type=script&lang=js"
import style0 from "./Demand.vue?vue&type=style&index=0&id=2738e7ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2738e7ea",
  null
  
)

export default component.exports